import { useState } from 'react';
import { Box, Toolbar } from '@mui/material';
import { Outlet } from 'react-router-dom';
import AppFooter from './AppFooter';
import AppHeader from './AppHeader';
import AppSidebar from './AppSidebar';
import { useRealtimeSync } from '@/hooks/useRealtimeSync';

const DRAWER_WIDTH = 248;

export default function AppLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);

  // one place wires server events into the query cache for the whole session
  useRealtimeSync();

  return (
    <Box className="flex h-full">
      <AppHeader drawerWidth={DRAWER_WIDTH} onToggleNav={() => setMobileOpen((open) => !open)} />
      <AppSidebar
        drawerWidth={DRAWER_WIDTH}
        mobileOpen={mobileOpen}
        onClose={() => setMobileOpen(false)}
      />
      <Box
        component="main"
        className="flex min-w-0 flex-1 flex-col overflow-auto"
        sx={{ bgcolor: 'background.default' }}
      >
        <Toolbar />
        <Box className="flex-1 p-4 md:p-6">
          <Outlet />
        </Box>
        <AppFooter />
      </Box>
    </Box>
  );
}
